import { PageResponse } from "../../applications/constants/AppTypes";
import { buildRequestToParams } from "../../applications/utils/StringUtils";
import { AdminUserModel, UserStatisticSummary } from "../model/AppUserModel";
import { ApiClient } from "../api/ApiClient";

class UserServiceClass {
  findUserByPage(page: number, limit: number, userName: string) {
    const request = buildRequestToParams({
      page: page,
      limit: limit,
      user_name: userName,
    });
    return ApiClient.get<PageResponse<AdminUserModel[]>>("/api/users" + `?${request}`);
  }

  getUserStatisticSummary(userId: number){
    return ApiClient.get<UserStatisticSummary>(`api/user/${userId}/statistic-summary`)
  }

}
export const UserService = new UserServiceClass();
